import { makeLocalFavoriteStore } from 'Workspace/storage/makeLocalFavoriteStore';

const store = makeLocalFavoriteStore({
  favoriteKeysPrefix: 'workspace.project.favoriteActivityIds',
  allExpandedPrefix: 'workspace.project.allActivitiesExpanded',
  favoriteKeysParseErrorLabel: 'Failed to parse stored project favorite activity ids',
  allExpandedParseErrorLabel: 'Failed to parse stored all activities expanded state',
});

export const getProjectFavoriteActivityIdsStorageKey = store.getFavoriteKeysStorageKey;
export const getAllActivitiesExpandedStorageKey = store.getAllExpandedStorageKey;
export const loadFavoriteActivityIds = store.loadFavoriteKeys;
export const saveFavoriteActivityIds = store.saveFavoriteKeys;
export const loadAllActivitiesExpanded = store.loadAllExpanded;
export const saveAllActivitiesExpanded = store.saveAllExpanded;
